import { useCodeGenerationNavigationGuard } from "../hooks/useCodeGenerationNavigationGuard";

export function CodeGenerationGuard() {
    useCodeGenerationNavigationGuard();
    return null; // This component doesn't render anything
}